/**
 * Calculate auto-confirm availability status based on API response and quantity validation.
 *
 * @param params.queryError - Whether the API query resulted in an error
 * @param params.isQuantityExceeded - Whether the quantity exceeds max auto-confirmable limit
 * @param params.apiIsOutOfLeadTime - Whether the API indicates out of lead time (optional, defaults to false if not provided)
 * @param params.isManualSlots - Whether slots are generated manually (true for auto-confirmable orders)
 *
 * @returns Auto-confirm availability status containing:
 *   - isOutOfLeadTime: true if out of auto-confirm lead time (always false for manual slots)
 *   - isQuantityExceeded: true if quantity exceeds max auto-confirmable
 *   - isUnavailable: true if query error OR quantity exceeded (cannot auto-confirm)
 */
export const calculateAutoConfirmAvailability = (params: {
  queryError: boolean
  isQuantityExceeded: boolean
  apiIsOutOfLeadTime?: boolean
  isManualSlots: boolean
}) => {
  return {
    isOutOfLeadTime: params.isManualSlots ? false : params.apiIsOutOfLeadTime ?? false,
    isQuantityExceeded: params.isQuantityExceeded,
    isUnavailable: params.queryError || params.isQuantityExceeded
  }
}
